import { assertType } from '../assert-type';
import { hasKey } from '../validator';
export function match(switchCase, cases, defaultCase) {
    return hasKey(cases, switchCase) ? cases[switchCase] : defaultCase;
}
const direction = 'N';
const res = match(direction, {
    E: 2,
    N: 3,
    S: 4,
    W: 5,
});
const res2 = match('N', {
    E: 2,
    N: 3,
    S: 4,
    W: 5,
}, 999);
assertType();
assertType();
